import { createContext, useContext } from "react";
import type { Need } from "../lib/needsYou";

/** Shell-wide actions and data that pages may use (Home starts the tour, reads "needs you"). */
export interface ShellUi {
  openPalette: () => void;
  openHelp: () => void;
  startTour: () => void;
  needs: Need[];
  needsTotal: number;
}

export const ShellUiContext = createContext<ShellUi>({
  openPalette: () => {},
  openHelp: () => {},
  startTour: () => {},
  needs: [],
  needsTotal: 0,
});

export function useShellUi(): ShellUi {
  return useContext(ShellUiContext);
}
